import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { RentCharge } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "RentCharge";
export const RentChargeService = {
	endpoint,
	createSingle: async (data: RentCharge) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getByAgreement: async (id: number) => await FetchInterceptor(`${process.env.REACT_APP_SERVER_APIURL}/${endpoint}/GetByAgreement/${id}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: RentCharge) => await Service.updateSingleById(endpoint, id, data)
}